export default "__VITE_ASSET__Ctl63BKc__"